import { ChangeCandidateDto } from '../change-candidate-dto';
import { PackagingSystemDto } from './packaging-system-dto';

export class ChangePackagingSystemCandidateDto extends ChangeCandidateDto {
    updatedPackagingSystem!: PackagingSystemDto;
    existingPackagingSystem!: PackagingSystemDto;
}
